<script setup>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import App from '@/components/Paths/PreSettlementFunding/App.vue';
import EmailLinkAndRetreaver from '@/components/Paths/WorkersCompV2/WorkersCompComponents/EmailLinkAndRetreaver.vue';
</script>

<template>
  <Header :show-retreaver-number="false" :showMVAStyleLogo="true"/>
  <div class="main-wrapper">
    <App/>
    <EmailLinkAndRetreaver
      class="email-link"
      :show-retreaver-number="false"
    />
    <Footer :showMVAStyleLogo="true"/>
  </div>
</template>

<style scoped lang="scss">
@use "@/assets/style/constants";
@use "@/assets/style/flow-style";
</style>